import { useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export type SinglePlantViewType = 'tabs' | 'accordion';

export const useUiStore = defineStore('ui', () => {
  const locale = useLocalStorage('ui_locale', 'en');
  const sideMenuCollapsed = useLocalStorage('ui_side_menu_collapsed', false);
  const singlePlantViewType = useLocalStorage<SinglePlantViewType | null>(
    'ui_single_plant_view_type',
    null,
  );

  const showSinglePlantAsTabs = computed(
    () =>
      singlePlantViewType.value === null ||
      singlePlantViewType.value === 'tabs',
  );
  const showSinglePlantAsAccordion = computed(
    () => singlePlantViewType.value === 'accordion',
  );

  function setLocale(newLocale: string): void {
    locale.value = newLocale;
  }

  function setSideMenuCollapsed(collapsed: boolean): void {
    sideMenuCollapsed.value = collapsed;
  }

  function setSinglePlantViewType(viewType: SinglePlantViewType | null): void {
    singlePlantViewType.value = viewType;
  }

  return {
    locale,
    sideMenuCollapsed,
    singlePlantViewType,
    showSinglePlantAsTabs,
    showSinglePlantAsAccordion,
    setLocale,
    setSideMenuCollapsed,
    setSinglePlantViewType,
  };
});
